import * as Yup from 'yup';
import * as moment from 'moment';

export function setInitialValues(draftData) {
    let rateFromDate = new Date();
    let rateToDate = new Date();
    rateToDate.setDate(rateToDate.getDate() + 30);

    return {
        //basic info
        userName: draftData?.customerName ? draftData?.customerName : '',
        phoneNumber: draftData?.contactNumber ? draftData?.contactNumber : '',
        businessName: draftData?.locationName ? draftData?.locationName : '',
        email: draftData?.emailAddress ? draftData?.emailAddress : '',
        address: draftData?.locationAddress?.street ? draftData?.locationAddress?.street : '',
        city: draftData?.locationAddress?.city ? draftData?.locationAddress?.city : '',
        state: draftData?.locationAddress?.state ? draftData?.locationAddress?.state : '',
        zip: draftData?.locationAddress?.zipCode ? draftData?.locationAddress?.zipCode : '',
        notes: draftData?.notes ? draftData?.notes : '',

        //bill To
        billToCheckBox: false,
        billToUserName: draftData?.billingAddress?.name ? draftData?.billingAddress?.name : '',
        billToEmail: draftData?.billToEmailAddress ? draftData?.billToEmailAddress : '',
        otherToEmail: draftData?.otherContactEmail ? draftData?.otherContactEmail : '',
        billToPhoneNumber: draftData?.billingAddress?.contactNumber ? draftData?.billingAddress?.contactNumber : '',
        billToBusinessName: draftData?.billingAddress?.locationName ? draftData?.billingAddress?.locationName : '',
        billToAddress: draftData?.billingAddress?.street ? draftData?.billingAddress?.street : '',
        billToCity: draftData?.billingAddress?.city ? draftData?.billingAddress?.city : '',
        billToState: draftData?.billingAddress?.state ? draftData?.billingAddress?.state : '',
        billToZip: draftData?.billingAddress?.zipCode ? draftData?.billingAddress?.zipCode : '',
        taxId: draftData?.businessInfo?.taxId ? draftData?.businessInfo?.taxId : '',
        businessURL: draftData?.businessInfo?.businessUrl ? draftData?.businessInfo?.businessUrl : '',
        businessDescription: draftData?.businessInfo?.businessDescription ? draftData?.businessInfo?.businessDescription : '',

        //fee structure
        feeTypeRadio: draftData?.feeStructure?.feeType ? draftData?.feeStructure?.feeType : 'PERCENTAGE',
        percentageValue: draftData?.feeStructure?.feeTypePercentage?.fee ? draftData?.feeStructure?.feeTypePercentage?.fee : '',
        costPerPalletValue: draftData?.feeStructure?.feeTypeCostPallet?.fee ? draftData?.feeStructure?.feeTypeCostPallet?.fee : '',
        percentageCurrencyLists: draftData?.feeStructure?.feeTypePercentage?.currency ? draftData?.feeStructure?.feeTypePercentage?.currency : 'USD',
        costPerPalletCurrencyLists: draftData?.feeStructure?.feeTypeCostPallet?.currency ? draftData?.feeStructure?.feeTypeCostPallet?.currency : 'USD',
        selectLocation: draftData?.locationName ? draftData?.locationName : '', // as of now location name in basic info is set here as well
        selectPalletType: draftData?.feeStructure?.flatFee?.selectedPaalletType ? draftData?.feeStructure?.flatFee?.selectedPaalletType : 'gradeA',
        flatFeeValue: draftData?.feeStructure?.flatFee?.fee ? draftData?.feeStructure?.flatFee?.fee : '',
        flatFeeCurrencyLists: draftData?.feeStructure?.flatFee?.currency ? draftData?.feeStructure?.flatFee?.currency : 'USD',
        rateStartDate: draftData?.feeStructure?.flatFee?.rateStartDate ? moment(draftData?.feeStructure?.flatFee?.rateStartDate * 1000).format("YYYY-MM-DD") : rateFromDate.toISOString().substring(0, 10),
        rateExpDate: draftData?.feeStructure?.flatFee?.rateExpirationDate ? moment(draftData?.feeStructure?.flatFee?.rateExpirationDate * 1000).format("YYYY-MM-DD") : rateToDate.toISOString().substring(0, 10),
        personnelType: draftData?.feeStructure?.accountManagement?.personnelType ? draftData?.feeStructure?.accountManagement?.personnelType : '',
        personnelTypeContactName: draftData?.feeStructure?.accountManagement?.contactName ? draftData?.feeStructure?.accountManagement?.contactName : '',
        personnelTypeEmail: draftData?.feeStructure?.accountManagement?.email ? draftData?.feeStructure?.accountManagement?.email : '',
        commissionTypeRadio: draftData?.feeStructure?.commissionType?.commission === 'PERCENTAGE' ? 'COMMISSIONPERCENTAGE' :
            draftData?.feeStructure?.commissionType?.commission === 'FLATRATE' ? 'FLATRATE' : 'COMMISSIONPERCENTAGE',
        commissionPercentageValue: draftData?.feeStructure?.commissionType?.commission === 'PERCENTAGE' ? draftData?.feeStructure?.commissionType?.value : '',
        commissionFlatRateValue: draftData?.feeStructure?.commissionType?.commission === 'FLATRATE' ? draftData?.feeStructure?.commissionType?.value : '',

        //payment method
        paymentModeRadio: 'PT',
        invoicePaymentModeRadio: 'ach',
        invoiceSchedulePeriod: 'WEEKLY'
    };
}

const VALIDATION_SCHEMA = () => {
    let schemaAttributes = {
        //basic info
        userName: Yup.string().trim().required('Contact Name is required.'),
        phoneNumber: Yup.string().required('Phone number is required.').matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
        businessName: Yup.string().required('Company Name is required.'),
        email: Yup.string().email('Please enter a valid email.').required('Email is required.'),
        // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,"Please enter a valid email."),
        address: Yup.string().required('Address is required.'),
        city: Yup.string().required('City is required.'),
        state: Yup.string().required('State is required.'),
        zip: Yup.string().required('Zip is required.').min(5, "5 digits required.").max(5, "Zip code should be of 5 digits only."),
        notes: Yup.string().max(200, "Only 200 characters allowed."),

        //bill to
        billToUserName: Yup.string().trim().required('Billing Contact Name is required.'),
        billToEmail: Yup.string().email('Please enter a valid email.').required('Email is required.'),
        billToPhoneNumber: Yup.string().required('Billing Contact Phone number is required.').matches(/^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/, 'Phone number is not valid'),
        billToBusinessName: Yup.string().required('Billing Contact Company Name is required.'),
        billToAddress: Yup.string().required('Billing Contact Address is required.'),
        billToCity: Yup.string().required('Billing Contact City is required.'),
        billToState: Yup.string().required('Billing Contact State is required.'),
        billToZip: Yup.string().required('Billing Contact Zip is required.').min(5, "5 digits required.").max(5, "Zip code should be of 5 digits only."),
        otherToEmail: Yup.string().email('Please enter a valid email.'),

        //business info
        taxId: Yup.string().min(9, "9 digits required.").max(9, "Tax ID should be of 9 digits only."),
        businessURL: Yup.string().max(200, "Only 200 characters allowed."),
        businessDescription: Yup.string().max(200, "Only 200 characters allowed."),

        //fee type        
        // personnelTypeContactName: Yup.string().trim().required('Contact Name is required.'),
        // personnelTypeEmail: Yup.string().email('Please enter a valid email.').required('Email is required.'),
    }

    return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };
